import React from 'react';
import { ArrowRight } from 'lucide-react';

export const HeroSection = () => (
  <section className="relative pt-40 pb-20 md:pt-60 md:pb-40 px-6 overflow-hidden">
    <div className="container mx-auto relative z-10">
      <div className="max-w-4xl">
        <h1 className="heading-1 mb-8">
          Helping Small Businesses <br />
          <span className="text-[var(--brand-secondary)]">Get Online Fast</span>
        </h1>
        <p className="text-xl md:text-2xl text-[var(--text-secondary)] mb-12 max-w-2xl leading-relaxed">
          Affordable, custom websites built to suit your business. Focus on simplicity, functionality, and results.
        </p>
        <div className="flex flex-col sm:flex-row gap-6">
          <a href="#contact" className="btn-primary" data-testid="hero-start-project-cta">
            Start Project <ArrowRight className="ml-2 w-5 h-5" />
          </a>
          <a href="#services" className="btn-secondary" data-testid="hero-view-services-cta">
            View Services
          </a>
        </div>
      </div>
    </div>

    <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[800px] h-[800px] rounded-full bg-[var(--brand-primary)] opacity-[0.03] blur-3xl -z-0 pointer-events-none" />
    <div className="absolute bottom-0 left-0 -translate-x-1/4 w-[600px] h-[600px] rounded-full bg-[var(--brand-secondary)] opacity-[0.03] blur-3xl -z-0 pointer-events-none" />
  </section>
);
